import { HttpMock } from '#e2e-utils/mockScenarios';
import { ControllerStatus } from '#models/ControllerStatus.enum';
import { GerlRejectCode } from '#models/Gerl.model';
import { ControllerDataMapping } from '#models/MicroController.model';
import { ControllerDetails } from '#services/cve/ControllerDetails';
import { IterationStatusCode, LineOfBusiness, VettingIteration } from '#services/cve/VettingIteration';

const gerlDetails = {
  controlCode: 'Gerl',
  statusCode: ControllerStatus.MANUAL_CHECK_REQUIRED,
  check: {
    requestorId: 'CVE',
    requestDateTime: '2024-05-21T13:29:56.409Z',
    responseDateTime: '2024-05-21T13:29:56.409Z',
    expirationDateTime: '2025-05-21T13:29:56.409Z',
    controlData: {
      companyId: '113',
      escalationContact: 'test@allianz-trade.com',
      gerl: {
        lastUpdateDate: '2024-05-20',
        isGerlCompliant: true,
        isUpGerlCompliant: undefined,
        isUltimateParent: false,
        isRelatedCompaniesListed: false,
        companies: [
          {
            id: '113',
            type: 'MAIN',
          },
        ],
      } satisfies ControllerDataMapping['Gerl']['gerl'],
      rejectCode: GerlRejectCode.ULTIMATE_PARENT_COMPANY_UNKNOWN,
      requestData: {
        buCode: 'SFAC',
        ultimateParentCompanyId: '1000',
      },
    },
  },
} satisfies ControllerDetails;

export const gerlAdditionalCheckedMocks: HttpMock[] = [
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId$',
    },
    response: {
      status: 200,
      body: {
        iterationId: 'iterationId',
        companyId: '113',
        lineOfBusiness: LineOfBusiness.TCI,
        statusCode: IterationStatusCode.CREATED,
        creation: {
          creationDateTime: '2024-04-19T10:05:42.156Z',
          creatorId: 'CVE',
          ownerId: 'CVE',
        },
        controls: [gerlDetails],
        customProperties: {},
      } satisfies VettingIteration,
    },
  },
  {
    request: {
      method: 'GET',
      urlPathPattern: '^/iterations/iterationId/controls/Gerl$',
    },
    response: {
      status: 200,
      body: gerlDetails,
    },
  },
];
